export const mapPaymentLinkData = (data) => {
  const statusMap = {
    total: 0,
    active: 0,
    complete: 0,
    expired: 0,
    pending: 0,
  };

  data?.forEach((item) => {
    const status = item['payment_links.status'];
    const count = Number(item['payment_links.count']) || 0;
    statusMap[status] = count;
    statusMap.total += count;
  });

  return statusMap;
};

export const mapTransactionData = (data) => {
  const failedStatuses = new Set([
    'failed',
    'authentication_failed',
    'authentication_rejected',
    'authentication_successful',
    'authentication_not_supported',
    'authentication_pending',
    'authorized_declined',
    'authorization_declined',
    'authentication_unavailable',
    'authentication_available',
    'authentication_attempted',
    'authentication_unsuccessful',
  ]);
  return data?.reduce(
    (acc, item) => {
      const status = item['transactions.status']?.toLowerCase();
      const totalRevenue = Number(item['transactions.totalRevenue']) || 0;
      const totalTransactions = Number(item['transactions.totalTransactions']) || 0;
      const tokenAttempts = Number(item['transactions.tokenAttempts']) || 0;

      if (failedStatuses?.has(status)) {
        acc.failed = {
          totalRevenue: (acc?.failed?.totalRevenue || 0) + totalRevenue,
          totalTransactions: (acc?.failed?.totalTransactions || 0) + totalTransactions,
        };
      } else {
        acc[status] = {
          totalRevenue: (acc[status]?.totalRevenue || 0) + totalRevenue,
          totalTransactions: (acc[status]?.totalTransactions || 0) + totalTransactions,
        };
      }

      acc.totalRevenue += totalRevenue;
      acc.totalTransactions += totalTransactions;
      acc.tokenAttempts += tokenAttempts; // Accumulate tokenAttempts globally

      return acc;
    },
    {
      totalRevenue: 0,
      totalTransactions: 0,
      tokenAttempts: 0,
      failed: { totalRevenue: 0, totalTransactions: 0 },
    },
  );
};

export const mapSubscriptionData = (subscriptionReport) => {
  const pivot = subscriptionReport?.tablePivot?.() || [];
  const subscriptionData = {};

  pivot?.forEach((row) => {
    const status = row['subscriptions.status'];
    const count = Number(row['subscriptions.subscriptionCount']) || 0;
    subscriptionData[status] = count;
  });

  return subscriptionData;
};

export const mapTopPlansData = (data) => {
  if (!Array.isArray(data)) return [];
  return data
    ?.map((item) => ({
      plan_id: item['subscriptions.plan_id'],
      total: Number(item['subscriptions.subscriptionCount']) || 0,
      paid: Number(item['subscriptions.paidSubscriptions']) || 0,
      inactive: Number(item['subscriptions.inactiveSubscriptions']) || 0,
      paused: Number(item['subscriptions.pausedSubscriptions']) || 0,
      cancelled: Number(item['subscriptions.cancelledSubscriptions']) || 0,
      draft: Number(item['subscriptions.draftSubscriptions']) || 0,
      open: Number(item['subscriptions.openSubscriptions']) || 0,
    }))
    ?.sort((a, b) => b.total - a.total)
    ?.slice(0, 5);
};

export const mapTopProductsData = (data) => {
  if (!Array.isArray(data)) return [];
  return data
    ?.map((item) => ({
      product_name: item['subs_by_products.name'],
      product_id: item['subs_by_products.product_id'],
      total: Number(item['subs_by_products.totalSubscriptionsByProducts']) || 0,
    }))
    ?.sort((a, b) => b.total - a.total)
    ?.slice(0, 5);
};

export const capitalizeWords = (str = '') => {
  return str
    ?.split?.(' ')
    ?.map?.((word) => word?.charAt?.(0)?.toUpperCase?.() + word?.slice?.(1))
    ?.join?.(' ');
};

export const hiddenCardNumber = (cardNumber) => {
  const first6 = cardNumber?.slice?.(0, 6);
  const last4 = cardNumber?.slice?.(-4);
  const maskedLength = cardNumber?.length - 10;
  const masked = 'x'.repeat(maskedLength);

  // merge and insert spaces every 4 characters
  const formatted = (first6 + masked + last4)
    ?.match?.(/.{1,4}/g) // split into chunks of 4
    ?.join?.(' ');

  return formatted;
};

export const formatAmount = (amount, currency = 'PKR') => {
  const fractionDigits = currency === 'OMR' ? 3 : 2;
  return Number(amount || 0)?.toLocaleString('en-US', {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  });
};

export const transformToMethodsGatewaysMap = (data = []) => {
  const methodMap = {};
  const gatewayMap = {};
  let totalCount = 0;

  data?.forEach((row) => {
    const method = row['usage_by_methods_gateways.payment_method']?.trim() || 'unknown';

    const gateway = row['usage_by_methods_gateways.payment_gateway'] || 'unknown';

    const value = Number(row['usage_by_methods_gateways.total_count'] || 0);

    totalCount += value;

    // aggregate methods
    methodMap[method] = (methodMap[method] || 0) + value;

    // aggregate gateways (global, not per method)
    gatewayMap[gateway] = (gatewayMap[gateway] || 0) + value;
  });

  const methods = Object.entries(methodMap).map(([name, value]) => ({
    name,
    value,
  }));

  const gateways = Object.entries(gatewayMap).map(([name, value]) => ({
    name,
    value,
  }));

  return { methods, gateways, totalCount };
};
